var React = require('react');

function SingleOrDoubleGazedWallSystem (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M68.41 0H16.71V16.63H0V68.33H51.1648L68.41 51.6008V0ZM1.8 18.43H16.71V51.026L1.8 65.3204V18.43ZM17.972 52.3098L3.13926 66.53H50.1553L50.0812 52.3098H17.972ZM18.51 50.5098H50.0718L49.9047 18.43H18.51V50.5098ZM51.8812 52.3098L51.9477 65.0628L65.0941 52.3098H51.8812ZM66.61 50.5098H51.8718L51.6953 16.63H18.51V1.8H66.61V50.5098Z","fill":"black"}));
}

SingleOrDoubleGazedWallSystem.defaultProps = {"width":"69","height":"69","viewBox":"0 0 69 69","fill":"none"};

module.exports = SingleOrDoubleGazedWallSystem;

SingleOrDoubleGazedWallSystem.default = SingleOrDoubleGazedWallSystem;
